var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"nav-item nav-search"},[_c('a',{staticClass:"nav-link nav-link-search",on:{"click":function($event){return _vm.$router.push({
        name: 'search-filter',
      })}}},[_c('feather-icon',{attrs:{"icon":"SearchIcon","size":"21"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }